import { Pipe, PipeTransform } from "@angular/core";
@Pipe({ name: "linebreak" })
export class LineBreakPipe implements PipeTransform {
    transform(val) {
        // Syftar till att kunna line-breaka exempelvis innehåll som har \r\n i json
        return val?.replace(/\\r\\n/g, "\r\n");
    }
}
